import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Avatar } from '@lib/core/src/components/Avatar';
import palette from '@lib/core/src/theme/palette';
import { getInitials } from '@lib/core/src/utils/string-util';
import { Button, Typography } from '@mui/material';
import { Stack, styled, alpha } from '@mui/system';

import UserMenu from '@/components/UserMenu/UserMenu';
import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';
import RoutesMap from '@/enums/RoutesMap';

export const USER_DETAILS_HEIGHT = '68px';

const UserDetailsContainer = styled(Button)({
  textTransform: 'none',
  backgroundColor: palette.grey[2700],
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  cursor: 'pointer',
  height: USER_DETAILS_HEIGHT,
  padding: '8px',
  '&:hover': {
    backgroundColor: alpha(palette.black, 0.05)
  }
});

const Name = styled(Typography)({
  alignSelf: 'flex-start',
  color: palette.black,
  fontSize: '13px',
  fontWeight: 600,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

const Email = styled(Typography)({
  fontSize: '12px',
  color: palette.grey[500],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

const UserDetails = () => {
  const navigate = useNavigate();
  const { currentUser } = useLoginContext();
  const initials = getInitials(`${currentUser?.firstName} ${currentUser?.lastName}`);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<undefined | HTMLElement>();

  return (
    <UserDetailsContainer
      onClick={event => {
        if (!userMenuAnchorEl) {
          setUserMenuAnchorEl(event.currentTarget);
        }
      }}
    >
      <Avatar
        id={initials}
        src={currentUser?.imageUrl}
        sx={{
          width: 40,
          height: 40
        }}
      >
        {initials}
      </Avatar>
      <Stack sx={{ minWidth: 0, maxWidth: '100%' }}>
        <Name>{`${currentUser?.firstName} ${currentUser?.lastName}`}</Name>
        <Email>{currentUser?.email}</Email>
      </Stack>
      <UserMenu
        anchorEl={userMenuAnchorEl}
        setAnchorEl={setUserMenuAnchorEl}
        openPersonalSeetings={() => navigate(RoutesMap.PersonalSettings)}
      />
    </UserDetailsContainer>
  );
};

export default UserDetails;
